export const groupStatus = Object.freeze({
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
});
